import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgxPaginationModule } from "ngx-pagination";
import { RmRoutingModule } from "./rm-routing.module";
import { FilterPipeModule } from "ngx-filter-pipe";
import { FormGroup, FormControl, ReactiveFormsModule } from "@angular/forms";
import {
  MatSnackBarModule,
  MatDialogModule,
  MatAutocompleteModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatRadioModule,
  MatTooltipModule,
} from "@angular/material";
import { MyDatePickerModule } from "mydatepicker";
import { AppCommonModule } from "../common/common.module";
import { Daterangepicker, DaterangepickerConfig } from "ng2-daterangepicker";
import { DashboardComponent, DashboardService } from "./dashboard";
import { ProjectsComponent } from "./projects/projects.component";
import {
  TimesheetApprovalsComponent,
  TimesheetApprovalsService,
} from "./timesheet-approvals";
import { PlannedActualComponent } from "./planned-actual/planned-actual.component";
import { DeligateComponent } from "./deligate/deligate.component";
import { ProjectsService } from "./projects/projects.service";
import { DeligateService } from "./deligate/deligate.service";
import { PendingtimesheetDetailsComponent } from "./timesheet-approvals";
import { RejectionConfirmationDialogComponent } from "./timesheet-approvals";
import { TimesheetEntryComponent } from "./timesheet-entry/timesheet-entry.component";
import { TimesheetEntryService } from "./timesheet-entry/timesheet-entry.service";
import { TimesheetReportComponent } from "./timesheet-report/timesheet-report.component";
import { TimesheetReportService } from "./timesheet-report/timesheet-report.service";
import { EmployeeComponent } from "./employee/employee.component";
import { NotificationComponent } from "../common/notification/notification.component";
import { NotificationService } from "../common/notification/notification.service";
import { AddDeligateComponent } from "./deligate/add-deligate/add-deligate.component";
import { ApprovalListComponent } from "./timesheet-approvals";
import { RmGuard } from "./rm.guard";
import { PopoverModule } from "ngx-popover";
import { OrganizationalReportComponent } from "./organizational-report/organizational-report.component";
import { OrganizationalReportService } from "./organizational-report/organizational-report.service";
import { ReportHierarchyComponent } from "./organizational-report/report-hierarchy/report-hierarchy.component";
import { MyReportComponent } from "./my-report/my-report.component";
import { MyReportService } from "./my-report/my-report.service";
import { RejectedTimesheetDetailsComponent } from "./timesheet-approvals/rejected-timesheet-details/rejected-timesheet-details.component";
import { NonAdherenceListComponent } from "./non-adherence-list/non-adherence-list.component";
import { NonAdherenceListService } from "./non-adherence-list/non-adherence-list.service";
import { NonComplianceListComponent } from "./non-compliance-list/non-compliance-list.component";
import { NonComplianceListService } from "./non-compliance-list/non-compliance-list.service";
import { UtilsModule } from '../utils/utils.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RmRoutingModule,
    NgxPaginationModule,
    FilterPipeModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    Daterangepicker,
    MyDatePickerModule,
    AppCommonModule,
    PopoverModule,
    MatTooltipModule,
    UtilsModule
  ],
  exports: [MatSnackBarModule, MatRadioModule],
  entryComponents: [RejectionConfirmationDialogComponent],
  declarations: [
    NotificationComponent,
    DashboardComponent,
    ProjectsComponent,
    TimesheetApprovalsComponent,
    PlannedActualComponent,
    DeligateComponent,
    PendingtimesheetDetailsComponent,
    RejectionConfirmationDialogComponent,
    TimesheetEntryComponent,
    EmployeeComponent,
    AddDeligateComponent,
    ApprovalListComponent,
    OrganizationalReportComponent,
    ReportHierarchyComponent,
    MyReportComponent,
    RejectedTimesheetDetailsComponent,
    NonAdherenceListComponent,
    NonComplianceListComponent,
    TimesheetReportComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    NotificationService,
    DashboardService,
    ProjectsService,
    TimesheetApprovalsService,
    TimesheetEntryService,
    RmGuard,
    OrganizationalReportService,
    NonAdherenceListService,
    MyReportService,
    NonComplianceListService,
    DeligateService,
    TimesheetReportService
  ],
})
export class RmModule {}



// WEBPACK FOOTER //
// ./src/app/rm/rm.module.ts